export enum FacebookError {
  BUSINESS_USER_NOT_FOUND = "BUSINESS_USER_NOT_FOUND",
  FB_USER_IS_NOT_ADMIN = "FB_USER_IS_NOT_ADMIN",
  INVALID_OAUTH_ACCESS_TOKEN = "INVALID_OAUTH_ACCESS_TOKEN",
  MULTIPLE_SHOPIFY_PRODUCT_CATALOGS = "MULTIPLE_SHOPIFY_PRODUCT_CATALOGS",
  REFRESH_ALREADY_IN_PROGRESS = "REFRESH_ALREADY_IN_PROGRESS",
  SELLER_NOT_FOUND = "SELLER_NOT_FOUND",
  SHOPIFY_PRODUCT_CATALOG_NOT_FOUND = "SHOPIFY_PRODUCT_CATALOG_NOT_FOUND",
}
